<template>
  <q-card
    v-ripple
    :class="{'selected': selected, 'extended': hasDefaultSlot, 'empty': entries.length < 1}"
    class="timeline-tile cursor-pointer relative-position"
  >
    <q-icon
      name="done"
      class="checked"
    />
    <q-card-section class="tile-content-wrap flex justify-between q-gutter-sm wrap overflow-hidden">
      <div class="main-slot">
        <div class="tile-counter text-bold text-blue-9">
          <slot name="count">
            {{ commaNumber(entries.length) }}
          </slot>
        </div>
        <div class="text-bold">
          {{ title }}
        </div>
      </div>
      <div v-if="hasDefaultSlot" class="extended-slot">
        <slot />
      </div>
    </q-card-section>

    <q-tooltip
      v-if="tooltip && !$q.platform.is.mobile"
    >
      {{ tooltip }}
    </q-tooltip>
  </q-card>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    },
    entries: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
